import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = {
    date: String
  }

  connect() {
    if (this.dateValue) {
      this.updateCountdown()
      this.interval = setInterval(() => {
        this.updateCountdown()
      }, 1000)
    }
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateCountdown() {
    const eventDate = new Date(this.dateValue)
    const now = new Date()
    const difference = eventDate - now

    if (difference <= 0) {
      this.displayTarget.textContent = "Гонка началась!"
      if (this.interval) {
        clearInterval(this.interval)
      }
      return
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24))
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((difference % (1000 * 60)) / 1000)

    const parts = []
    if (days > 0) parts.push(`${days} д.`)
    if (hours > 0) parts.push(`${hours} ч.`)
    if (minutes > 0) parts.push(`${minutes} мин.`)
    if (seconds > 0 || parts.length === 0) parts.push(`${seconds} сек.`)

    this.displayTarget.textContent = parts.join(' ')
  }
}
